import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';
import config from '@plone/volto/registry';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const TeaserDefaultTemplate = (props) => {
  const {
    data,
    isEditMode,
    imageBackground = false,
    textLateral = false,
  } = props;

  const {
    aspectRatioDesktop = '56.25%',
    aspectRatioMobile = '66.6666%',
    verticalAlign = 'center',
    horizontalAlign = 'center',
    image_alt = '',
    title,
    subtitle,
    description,
    hideImage,
    hideDescription,
    hideSubtitle,
  } = data;

  // console.log(data);

  const intl = useIntl();

  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const url = data.preview_image?.[0]?.['@id'];
  const review_state = data.href?.[0]?.review_state;

  const Image = config.getComponent('Image').component;
  const { openExternalLinkInNewTab } = config.settings;

  return (
    <div
      className={cx('block', 'teaser')}
      style={{
        '--teaser-user-aspect-ratio-mobile': aspectRatioMobile,
        '--teaser-user-aspect-ratio-desktop': aspectRatioDesktop,
        '--teaser-vertical-align': verticalAlign,
        '--teaser-horizontal-align': horizontalAlign,
      }}
    >
      {!href && isEditMode && (
        <Message>
          <div className="teaser-item placeholder">
            <img src={imageBlockSVG} alt="" />
            <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
          </div>
        </Message>
      )}
      {href && (
        <MaybeWrap
          condition={!isEditMode}
          as={UniversalLink}
          href={href['@id']}
          target={
            data.openLinkInNewTab ||
            (openExternalLinkInNewTab && !isInternalURL(href['@id']))
              ? '_blank'
              : null
          }
        >
          <div
            className={cx(
              'item',
              { back: imageBackground },
              { 'text-lateral': textLateral },
            )}
          >
            {!hideImage &&
            (href.hasPreviewImage || href.image_field || image) ? (
              <div className={'wrap'}>
                {url && !image?.image_field ? (
                  <Image
                    src={url}
                    alt={image_alt}
                    loading="lazy"
                    responsive={true}
                  />
                ) : (
                  (href.hasPreviewImage || href.image_field || image) && (
                    <Image
                      item={image || href}
                      imageField={image ? image.image_field : href.image_field}
                      alt={image_alt}
                      loading="lazy"
                      responsive={true}
                    />
                  )
                )}
              </div>
            ) : null}
            <div className={'info'}>
              {subtitle && !hideSubtitle ? (
                <div>
                  <span>{data.subtitle}</span>
                </div>
              ) : null}
              <h2
                className={cx({
                  [`review-state-${review_state}`]: review_state,
                })}
              >
                {title}
              </h2>
              {description && !hideDescription ? <p>{description}</p> : null}
            </div>
          </div>
        </MaybeWrap>
      )}
    </div>
  );
};

TeaserDefaultTemplate.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
  imageBackground: PropTypes.bool,
  textLateral: PropTypes.bool,
};

export default TeaserDefaultTemplate;
